import {
  createPasswordValidationSchema,
  passwordFormDefaultValues,
} from '../../../../lib/utils/validation/password-validation';

/**
 * Set Password Form Schema
 *
 * Defines the validation schema, type definition, and default values for the account activation
 * password setting form. This module reuses common password validation logic from a shared
 * password validation module.
 *
 * Exports:
 * - setPasswordFormValidationSchema: Zod validation schema for password setting, created from common password validation schema
 * - setPasswordFormType: TypeScript type for the set password form, aliased from common password form type
 * - setPasswordFormDefaultValue: Default initial values for the form, reused from common password defaults
 *
 * @module setPasswordForm
 */

import { z } from 'zod';

export const getSetPasswordFormValidationSchema = (t: (key: string) => string) =>
  z.object({
    firstName: z.string().min(1, { message: t('FIRST_NAME_IS_REQUIRED') || 'First name is required' }),
    lastName: z.string().min(1, { message: t('LAST_NAME_IS_REQUIRED') || 'Last name is required' }),
  }).and(createPasswordValidationSchema(t));

export const setPasswordFormDefaultValue = {
  ...passwordFormDefaultValues,
  firstName: '',
  lastName: '',
};
